export const WEB_VERSION = {
	version: '1.0.0',
	build: 28,
};
